import React from 'react';
import './Input.style.css';

interface InputProps {
  placeholder: string;
  type: string;
  name: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

function Input(
  { placeholder, type, name, onChange }: InputProps,
  ref: React.Ref<HTMLInputElement>
) {
  return (
    <div className="tgc-input-container">
      <input
        ref={ref}
        name={name}
        onChange={onChange}
        className="tgc-input-field"
        type={type}
        autoComplete="new-password"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck="false"
        data-form-type="other"
        placeholder={placeholder}
      />
      <span className="tgc-input-placeholder">{placeholder}</span>
    </div>
  );
}

export default React.forwardRef(Input);
